/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import "./InvoiceStyle.css";
import LayoutFooter from "../inc/LayoutFooter";
import LayoutHeader from "../inc/LayoutHeader";
import { RollbackOutlined, PrinterOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import { Layout } from "antd";
import {
  Button,
  Card,
  Spin,
  Row,
  Col,
  Tag,
  Space,
  Select,
  Table,
  Avatar,
} from "antd";
import { displayMessage, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE } from "../../constants/messages";
import {
  ORDER_DETAIL,
  IMAGE_BASE_URL,
  ORDER_INVOICE,
  ORDER_STATUS_UPDATE,
  ORDER_CANCEL_UPDATE,
} from "../../constants/api";
import { CURRENCY } from "../../constants/constent";

function OrderDetail() {
  const { Content } = Layout;
  const { id } = useParams();
  const [state, setState] = useState([]);
  const [loading, setIsLoading] = useState(false);
  const [syncing, setStatusSync] = useState(false);
  const [orderDetail, setOrder] = useState(null);
  let navigate = useNavigate();

  useLayoutEffect(() => {
    getIdDetail();
  }, []);

  const getIdDetail = () => {
    setIsLoading(true);
    var data = new FormData();
    data.append("gen_order_id", id);
    const successFn = async function (data) {
      if (data.status === true) {
        setOrder(data.data);
        setState(
          data["data"]["products"].map((row, index) => ({
            key: index,
            no: index + 1,
            itemName: row.product_name,
            price: CURRENCY + row.product_price,
            qty: row.product_qty,
            total:
              CURRENCY + Number(row.product_price) * Number(row.product_qty),
          }))
        );
        setIsLoading(false);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Get Data");
    };
    postAPI(ORDER_DETAIL, data, successFn, errorFn);
  };

  const setOrderStatus = (value) => {
    setStatusSync(true);
    var data = new FormData();
    data.append("order_id", orderDetail.id);
    data.append("order_status", value);
    const successFn = async function (data) {
      if (data.status === true) {
        getIdDetail();
        setStatusSync(false);
      } else {
        setStatusSync(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setStatusSync(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Get Data");
    };
    postAPI(ORDER_STATUS_UPDATE, data, successFn, errorFn);
  };

  const setOrderCancelStatus = (value) => {
    setStatusSync(true);
    var data = new FormData();
    data.append("order_id", orderDetail.id);
    data.append("cancel_status", value);
    const successFn = async function (data) {
      if (data.status === true) {
        getIdDetail();
        setStatusSync(false);
      } else {
        setStatusSync(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setStatusSync(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Get Data");
    };
    postAPI(ORDER_CANCEL_UPDATE, data, successFn, errorFn);
  };
  const orderStatus = [
    {
      value: "Pending",
      label: "Pending",
    },
    {
      value: "Accept",
      label: "Accept",
    },
    {
      value: "Shipped",
      label: "Shipped",
    },
    {
      value: "Delivered",
      label: "Delivered",
    },
    {
      value: "Cancelled",
      label: "Cancelled",
    },
    {
      value: "User-Cancelled",
      label: "User-Cancelled",
    },
  ];
  const orderCancelStatus = [
    {
      value: "In-Progress",
      label: "In-Progress",
    },
    {
      value: "Payment-Init",
      label: "Payment-Init",
    },
    {
      value: "Completed",
      label: "Completed",
    },
  ];
  const orderCancelStatusCash = [
    {
      value: "In-Progress",
      label: "In-Progress",
    },
    {
      value: "Completed",
      label: "Completed",
    },
  ];
  const columns = [
    {
      title: "NO",
      dataIndex: "no",
      key: "no",
    },
    {
      title: "ITEM NAME",
      dataIndex: "itemName",
      key: "itemName",
    },
    {
      title: "PRICE",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "QTY",
      dataIndex: "qty",
      key: "qty",
    },
    {
      title: "TOTAL",
      dataIndex: "total",
      key: "total",
    },
  ];

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Spin spinning={loading}>
            {orderDetail !== null ? (
              <Row className="spacebetwen">
                <Col span={16}>
                  <Card className="card-info">
                    <Row>
                      <Col span={12}>
                        <span className="page-header-title">
                          Order #
                          {orderDetail !== null ? orderDetail.gen_order_id : ""}
                        </span>
                        <p className="mt5 date">
                          <span>{orderDetail.order_date}</span>
                        </p>
                        <p className="mt5 date">
                          <span>
                            Total Amount :&nbsp;
                            <Tag color={"success"}>
                              {orderDetail !== null
                                ? CURRENCY + orderDetail.total_bill
                                : ""}
                            </Tag>
                          </span>
                        </p>
                      </Col>

                      <Col span={12}>
                        <span className="mb5 floatR">
                          <Space>
                            <Button
                              className="floatR"
                              type="primary"
                              disabled={orderDetail.status !== "Delivered"}
                              onClick={(e) => {
                                const encodedId = btoa(id.toString());
                                const url = `${ORDER_INVOICE}${encodedId}`;
                                window.open(url, "_blank");
                              }}
                              icon={<PrinterOutlined />}
                            >
                              Print Invoice
                            </Button>
                            <Button
                              style={{
                                marginTop: "5px",
                                marginBottom: "5px",
                              }}
                              onClick={() => navigate(-1)}
                              type="primary"
                              ghost
                            >
                              <RollbackOutlined />
                            </Button>
                          </Space>
                          <br />

                          <div className="mt5">
                            <span className="mt5 floatR">
                              Order Status :&nbsp;
                              <Tag
                                color={
                                  orderDetail.payment_status === "Pending"
                                    ? "processing"
                                    : orderDetail.payment_status === "Success"
                                    ? "success"
                                    : "magenta"
                                }
                              >
                                {orderDetail.status}
                              </Tag>
                            </span>
                          </div>
                          <div className="mt5">
                            <span className="mt5 floatR">
                              Payment Method :&nbsp;
                              <Tag color={"magenta"}>
                                {orderDetail.payment_by}
                              </Tag>
                            </span>
                          </div>
                          <div className="mt5">
                            <span className="mt5 floatR">
                              Payment Status :&nbsp;
                              <Tag
                                color={
                                  orderDetail.payment_status === "Pending"
                                    ? "processing"
                                    : orderDetail.payment_status === "Success"
                                    ? "success"
                                    : "magenta"
                                }
                              >
                                {orderDetail.payment_status}
                              </Tag>
                            </span>
                          </div>
                        </span>
                      </Col>
                    </Row>
                    <Table
                      loading={loading ? true : false}
                      columns={columns}
                      dataSource={state}
                      scroll={{ x: 240 }}
                    />
                    <hr />
                    <div className="footer">
                      <div className="terms">
                        <p className="tc bold">Terms & Coditions</p>
                        <p>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Velit non praesentium doloribus. Quaerat vero
                          iure itaque odio numquam, debitis illo quasi
                          consequuntur velit, explicabo esse nesciunt error
                          aliquid quis eius!
                        </p>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col span={7}>
                  {orderDetail.status !== "Delivered" ||
                  orderDetail.status !== "Canceled" ? (
                    <Card className="mb5" title="Order Setup" loading={syncing}>
                      <Select
                        value={orderDetail.status}
                        style={{
                          width: "100%",
                        }}
                        disabled={
                          orderDetail.status === "User-Cancelled" || syncing
                        }
                        loading={syncing}
                        options={orderStatus}
                        onChange={setOrderStatus}
                      />
                    </Card>
                  ) : null}
                  {orderDetail.status === "User-Cancelled" &&
                  orderDetail.order_canceled != null ? (
                    <Card
                      className="mb5"
                      title="Order Cancel Status"
                      loading={syncing}
                    >
                      <Select
                        value={orderDetail.order_canceled.status}
                        style={{
                          width: "100%",
                        }}
                        disabled={
                          orderDetail.order_canceled.status === "Completed" ||
                          syncing
                        }
                        loading={syncing}
                        options={
                          orderDetail.payment_by === "Cash" ||
                          (orderDetail.payment_by === "COD" &&
                            orderDetail.payment_status === "Pending")
                            ? orderCancelStatusCash
                            : orderCancelStatus
                        }
                        onChange={setOrderCancelStatus}
                      />
                    </Card>
                  ) : null}

                  {orderDetail.payment_by !== "Cash" &&
                  orderDetail.payment_by !== "COD" &&
                  orderDetail.status === "User-Cancelled" &&
                  orderDetail.order_canceled != null &&
                  orderDetail.order_canceled.order_trans != null ? (
                    <Card
                      className="mb5"
                      title="Refund Trans:"
                      loading={syncing}
                    >
                      <p>
                        {
                          orderDetail.order_canceled.order_trans
                            .order_payment_id
                        }
                      </p>
                      <p>
                        {
                          orderDetail.order_canceled.order_trans
                            .order_canceled_refund_id
                        }
                      </p>
                      <p>
                        {
                          orderDetail.order_canceled.order_trans
                            .refund_inti_date
                        }
                      </p>
                      <p>
                        {
                          orderDetail.order_canceled.order_trans
                            .order_canceled_refund_message
                        }
                      </p>
                    </Card>
                  ) : null}
                  <Card className="mb5" title="Customer Information">
                    <Row className="spacebetwen">
                      <Col span={6}>
                        <Avatar
                          size="large"
                          shape="square"
                          src={
                            orderDetail !== null && orderDetail.user.image
                              ? IMAGE_BASE_URL + orderDetail.user.image.filePath
                              : ""
                          }
                        />
                      </Col>
                      <Col span={18}>
                        <p className="date">
                          <strong>{orderDetail.address.name}</strong>
                        </p>
                        <p className="date">
                          <span>{orderDetail.user.email}</span>
                        </p>
                        <p className="date">
                          <span>{orderDetail.address.phone}</span>
                        </p>
                      </Col>
                    </Row>
                  </Card>
                  <Card className="mb5" title="Shipping Detail">
                    <p className="date">
                      Name: <strong>{orderDetail.address.name}</strong>
                    </p>
                    <p className="date">
                      Mobile no: <strong>{orderDetail.address.phone}</strong>
                    </p>
                    <p className="date">
                      House no: <span>{orderDetail.address.house_no}</span>
                    </p>
                    <p className="date">
                      City:{" "}
                      <span>
                        {orderDetail.address.city +
                          " - " +
                          orderDetail.address.pin_code}
                      </span>
                    </p>
                    <p className="date">
                      State: <span>{orderDetail.address.state}</span>
                    </p>
                    <p className="date">
                      Country: <span>{orderDetail.address.country}</span>
                    </p>
                    <p className="date">
                      Full Address:{" "}
                      <span>{orderDetail.address.full_address}</span>
                    </p>
                  </Card>
                  <Card className="mb5" title="Order Amount">
                    <p className="spacebetwen">
                      <span>TOTAL MRP</span>
                      <span>₹{orderDetail.total_mrp}</span>
                    </p>
                    <p className="spacebetwen">
                      <span>DISCOUNT</span>
                      <span>-₹{orderDetail.total_discount}</span>
                    </p>

                    {orderDetail.coupon != null && (
                      <p className="bold spacebetwen">
                        <span>COUPON</span>
                        <span>₹{orderDetail.total_coupon_amt}</span>
                      </p>
                    )}

                    <p className="spacebetwen">
                      <span>DELIVERY CHARGE</span>
                      <span>₹{orderDetail.delivery_charge}</span>
                    </p>
                    <p className="bold spacebetwen">
                      <span>BILL AMOUNT</span>
                      <span>₹{orderDetail.total_bill}</span>
                    </p>
                  </Card>
                </Col>
              </Row>
            ) : null}
          </Spin>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}
export default OrderDetail;
